import L from "leaflet";
import { initMapApp } from "../../../vendor/tbuck-software/map-engine-core/assets/ts/public/app";

const WORLD_TILE_SIZE = 256;
const WORLD_MIN_LAT = -85.05112878;
const WORLD_MAX_LAT = 85.05112878;
const WORLD_MIN_LNG = -180;
const WORLD_MAX_LNG = 180;

const applyProjectMapZoomLimits = function (this: L.Map): void {
    const updateMinZoom = (): void => {
        if (!window.MapEngineConfig?.limitZoomToWorldWidth) {
            return;
        }

        const containerWidth = this.getContainer()?.clientWidth || this.getSize().x;
        if (!containerWidth) return;

        const zoomSnap = typeof this.options.zoomSnap === 'number' && this.options.zoomSnap > 0
            ? this.options.zoomSnap
            : 0;
        const worldFitZoom = Math.max(0, Math.log2(containerWidth / WORLD_TILE_SIZE));
        const minZoom = zoomSnap > 0
            ? Math.ceil(worldFitZoom / zoomSnap) * zoomSnap
            : worldFitZoom;

        this.setMinZoom(minZoom);

        if (this.getZoom() < minZoom) {
            this.setZoom(minZoom, { animate: false });
        }
    };

    const updatePrimaryWorldBounds = (): void => {
        if (!window.MapEngineConfig?.limitPanToPrimaryWorld) {
            return;
        }

        const containerWidth = this.getContainer()?.clientWidth || this.getSize().x;
        const zoom = this.getZoom();
        if (!containerWidth || !Number.isFinite(zoom)) return;

        const visibleLngSpan = Math.min(360, (360 * containerWidth) / (WORLD_TILE_SIZE * (2 ** zoom)));
        const overscrollFraction = Math.max(0, Math.min(0.5, window.MapEngineConfig.worldPanOverscrollFraction ?? 0));
        const overscrollLng = visibleLngSpan * overscrollFraction;

        this.setMaxBounds(L.latLngBounds(
            L.latLng(WORLD_MIN_LAT, WORLD_MIN_LNG - overscrollLng),
            L.latLng(WORLD_MAX_LAT, WORLD_MAX_LNG + overscrollLng)
        ));
        this.options.maxBoundsViscosity = 1.0;
    };

    const updateConstraints = (): void => {
        updateMinZoom();
        updatePrimaryWorldBounds();
    };

    this.whenReady(updateConstraints);
    this.on('resize', updateConstraints);
    this.on('zoomend', updatePrimaryWorldBounds);
};

L.Map.addInitHook(applyProjectMapZoomLimits);

// Initialize the map using the Core logic
initMapApp();

const updateWidgetWidth = (): void => {
    const widget = document.querySelector<HTMLElement>('#widget');
    const widgetBase = widget?.querySelector<HTMLElement>('#widget-base');
    if (!widget || !widgetBase) return;

    const buttonCount = widgetBase.querySelectorAll('.widget-button').length;
    if (buttonCount === 0) return;

    const buttonWidth = 84;
    const gap = 2;
    const sideMargins = 10;
    const newWidth = buttonCount * buttonWidth + (buttonCount - 1) * gap + sideMargins;

    widget.style.setProperty('--widget-width', `${newWidth}px`);
};

updateWidgetWidth();
window.addEventListener('load', updateWidgetWidth);
window.addEventListener('resize', updateWidgetWidth);
